// src/app/router/config.jsx
import { lazy } from 'react';

// Lazy loading pages
export const HomePage = lazy(() => import('@pages/HomePage'));
export const ProfilePage = lazy(() => import('@pages/ProfilePage'));
export const RulesPage = lazy(() => import('@pages/RulesPage'));
export const BonusPage = lazy(() => import('@pages/BonusPage'));
export const WinnersPage = lazy(() => import('@pages/WinnersPage'));
export const StreamSettingsPage = lazy(() => import('@pages/StreamSettingsPage'));
export const LoginPage = lazy(() => import('@pages/LoginPage'));
export const RegisterPage = lazy(() => import('@pages/RegisterPage'));
export const MyChallengesPage = lazy(() => import('@pages/MyChallengesPage'));
export const ChallengeDetailPage = lazy(() => import('@pages/ChallengeDetailPage'));
export const ChallengeStartPage = lazy(() => import('@pages/ChallengeStartPage'));
export const AchievementsPage = lazy(() => import('@pages/AchievementsPage'));
export const SettingsPage = lazy(() => import('@pages/SettingsPage'));
export const UsersListPage = lazy(() => import('@pages/UsersListPage'));
export const GameModesPage = lazy(() => import('@pages/GameModesPage'));
export const ComingSoonPage = lazy(() => import('@pages/ComingSoonPage/ui/ComingSoonPage'));

export const routeConfig = [
  {
    path: '/',
    element: null, // Handled by RootRedirect
    isRoot: true,
  },
  {
    path: '/login',
    element: <LoginPage />,
    publicOnly: true,
  },
  {
    path: '/register',
    element: <RegisterPage />,
    publicOnly: true,
  },
  {
    path: '/rules',
    element: <RulesPage />,
  },
  {
    path: '/bonus',
    element: <BonusPage />,
  },
  {
    path: '/winners',
    element: <WinnersPage />,
  },
  {
    path: '/streamers',
    element: <ComingSoonPage title="ДЛЯ СТРИМЕРОВ" />,
  },
  {
    path: '/integrations',
    element: <ComingSoonPage title="ИНТЕГРАЦИИ" />,
  },
  {
    path: '/achievements',
    element: <ComingSoonPage title="ДОСТИЖЕНИЯ" />,
  },
  {
    path: '/my-games',
    element: <ComingSoonPage title="МОИ ИГРЫ" />,
  },
  {
    path: '/users',
    element: <UsersListPage />,
  },
  {
    path: '/profile',
    element: <ProfilePage />,
  },
  {
    path: '/profile/:username',
    element: <ProfilePage />,
  },
  // Protected Routes
  {
    path: '/my-challenges',
    element: <MyChallengesPage />,
    authRequired: true,
  },
  {
    path: '/challenge/start',
    element: <GameModesPage />,
    authRequired: true,
  },
  {
    path: '/challenge/:id',
    element: <ChallengeDetailPage />,
    authRequired: true,
  },
  {
    path: '/challenge/:id/view',
    element: <ChallengeDetailPage />,
    authRequired: true,
  },
  {
    path: '/challenge/:id/play',
    element: <ChallengeDetailPage />,
    authRequired: true,
  },
  {
    path: '/settings',
    element: <SettingsPage />,
    authRequired: true,
  },
];
